export const MODAL_TYPES = {
  VIEW_QUOTATION_DETAIL: 'VIEW_QUOTATION_DETAIL',
  ECCN_DETAIL: 'ECCN_DETAIL',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  // add more...
}
